import { render, staticRenderFns } from "./OtherIncomeAccReceivableReg.vue?vue&type=template&id=2e386ef8&"
import script from "./OtherIncomeAccReceivableReg.vue?vue&type=script&lang=js&"
export * from "./OtherIncomeAccReceivableReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports